import { render, staticRenderFns } from "./MovableTextBoxPropertyEditor.vue?vue&type=template&id=bace2226&scoped=true&"
import script from "./MovableTextBoxPropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./MovableTextBoxPropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bace2226",
  null
  
)

export default component.exports